import { gql } from "@apollo/client";
import { post, get, axiosLang, fetchLang } from "../util/http";
import axios from "axios";
const headers = {
	"content-type": "application/json"
}
// 创建作品
export const CREATE_WORKS = gql`
  mutation _CREATE_WORKS($params: Object!) {
    createWorks(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 更新作品
export const UPDATE_WORKS = gql`
  mutation _UPDATE_WORKS($params: Object!) {
    updateWorks(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 发布作品
export const RELEASE_WORKS = gql`
  mutation _RELEASE_WORKS($params: Object!) {
    release(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 发布作品
export const UPDATE_SPECTACLE = gql`
  mutation _UPDATE_SPECTACLE($id: String!) {
    updateWorksSpectacle(id: $id) {
      success
      info
      error
      result
    }
  }
`;

// 审核作品
export const CHECK_WORKS = gql`
  mutation _CHECK_WORKS($params: Object!) {
    checkWorks(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 查询全部作品
export const QUERY_WORKS = gql`
  query _QUERY_WORKS($params: Object!) {
    _works(condition: $params)
  }
`;

// 查询我的作品
export const SELF_WORKS = gql`
  query _SELF_WORKS($params: Object!) {
    _selfWorks(condition: $params)
  }
`;

// 查询首页作品
export const INDEX_WORKS = gql`
  query _INDEX_WORKS($params: Object!) {
    _pureWorks(condition: $params)
  }
`;

// 查询作品详情
export const WORKS_DETAILS = gql`
  query _WORKS_DETAILS($id: String!) {
    _workDetails(id: $id) {
      id
      fid
      editPicture
      uname
      uavator
      workDesc
      style
      workName
      imgUrlList
      materialList
      nodeList
      layout
      layoutWidth
      layoutHeight
      img
      desc
      status
    }
  }
`;

// 导出清单
export const EXPORT_DOC = gql`
  query _EXPORT_DOC($params: Object!) {
    exportExcel(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 创建作品导出材料清单
export const EXPORT_EXCEL = gql`
  query _EXPORT_EXCEL($params: Object!) {
    exportExcelOnline(work: $params) {
      result
      info
      success
      error
    }
  }
`;

// 修改备注
export const UPDATE_REMARKS = gql`
  mutation _UPDATE_REMARKS($params: Object!) {
    updateWorksRemarks(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 下架作品
export const FORBIDDEN_REMARKS = gql`
  mutation _FORBIDDEN_REMARKS($params: Object!) {
    forbiddenWorks(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 删除作品
export const DEL_WORKS = gql`
  mutation _DEL_WORKS($params: Object!) {
    delWorks(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 复制作品
export const COPY_WORKS = gql`
  mutation _COPY_WORKS($params: Object!) {
    copyWorks(works: $params) {
      result
      info
      success
      error
    }
  }
`;
//增加热度
export const INC_HOT = gql`
  mutation _INC_HOT($params: Object!) {
    incHot(works: $params) {
      info
      success
      error
    }
  }
`;

//首页展示取消
export const STARED_WORKS = gql`
  mutation _STARED_WORKS($params: Object!) {
    staredWorks(works: $params) {
      info
      success
      error
      result
    }
  }
`;

// 更新作品
export const UPDATE_WORKSMATERIAL = gql`
  mutation _UPDATE_WORKSMATERIAL($params: Object!) {
    updateWorksMaterial(condition: $params) {
      result
      info
      success
      error
    }
  }
`;

// 更新作品
export const VALIDATE_WORKSMATERIAL = gql`
  mutation _VALIDATE_WORKSMATERIAL($params: WorksDto!) {
    validateMaterialList(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 导出节点
export const EXPORT_NODEZIP = gql`
  query _EXPORT_NODEZIP($params: Object!) {
    exportNodeZip(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 作品详情导出
export const EXPORT_WORK = gql`
  query _EXPORT_WORK($params: Object!) {
    exportWork(works: $params) {
      result
      info
      success
      error
    }
  }
`;

// 建筑分类查询
export const OPUS_CATEGORY = gql`
  query _OPUS_CATEGORY($id: String!) {
    workCategory(id: $id) {
      id
      parentId
      typeName
      level
      show
      discard
      tmCreate
      tmModify
      order
      children
      mlTypeName
    }
  }
`;

// 建筑分类重名查询
export const DUPLICATION_NAME_CATEGORY = gql`
  query _DUPLICATION_NAME_CATEGORY($typeName: String, $parentId: String) {
    duplicationNameWorkCategory(typeName: $typeName, parentId: $parentId)
  }
`;

// 创建建筑分类
export const CREATE_OPUS_CATEGORY = gql`
  mutation _CREATE_OPUS_CATEGORY(
    $typeName: String
    $parentId: String
    $show: Boolean
    $order: Long
  ) {
    createWorkCategory(
      typeName: $typeName
      parentId: $parentId
      show: $show
      order: $order
    ) {
      result
      info
      success
      error
    }
  }
`;

// 修改建筑分类
export const UPDATE_OPUS_CATEGORY = gql`
  mutation _UPDATE_OPUS_CATEGORY(
    $typeName: String
    $id: String
    $show: Boolean
    $order: Long
  ) {
    updateWorkCategory(
      typeName: $typeName
      id: $id
      show: $show
      order: $order
    ) {
      result
      info
      success
      error
    }
  }
`;

// 移除建筑分类
export const REMOVE_OPUS_CATEGORY = gql`
  mutation _REMOVE_OPUS_CATEGORY($id: String!) {
    removeWorkCategory(id: $id) {
      result
      info
      success
      error
    }
  }
`;

// 调整建筑分类
export const MOVE_OPUS_CATEGORY = gql`
  mutation _MOVE_OPUS_CATEGORY(
    $sourceId: String
    $targetId: String
    $sourceOrder: Long
    $targetOrder: Long
  ) {
    moveWorkCategory(
      sourceId: $sourceId
      targetId: $targetId
      sourceOrder: $sourceOrder
      targetOrder: $targetOrder
    ) {
      result
      info
      success
      error
    }
  }
`;

// 保存风格顺序
export const OPUS_CATEGORY_ORDER = gql`
  mutation _OPUS_CATEGORY_ORDER($ids: [String]) {
    saveWorkCategoryOrder(ids: $ids) {
      result
      info
      success
      error
    }
  }
`;

// 风格管理查询
export const OPUS_STYLE = gql`
  query _OPUS_STYLE {
    styleManage
  }
`;

// 风格管理重名查询
export const DUPLICATION_NAME_STYLE = gql`
  query _DUPLICATION_NAME_STYLE($name: String) {
    duplicationNameStyle(name: $name)
  }
`;

// 创建设计风格
export const CREATE_OPUS_STYLE = gql`
  mutation _CREATE_OPUS_STYLE($name: String, $show: Boolean, $order: Long,$mlName:Object) {
    createStyleManage(name: $name, show: $show, order: $order,mlName:$mlName) {
      result
      info
      success
      error
    }
  }
`;
//创建新的设计风格
export const createStyleManage = async (options) => {
  return axios.post("/api/style/createStyleManage", options)
}

export const updateStyleManage = async (options) => {
  return axios.post("/api/style/updateStyleManage", options)
}

// 新增建筑类型
export const createWorkCategory = async (options) => {
  return axios.post("/api/category/createWorkCategory", options)
}

// 更新建筑类型
export const updateWorkCategory = async (options) => {
  return axios.post("/api/category/updateWorkCategory", options)
}


// 新的创建设计风格

// 修改设计风格
export const UPDATE_OPUS_STYLE = gql`
  mutation _UPDATE_OPUS_STYLE(
    $name: String
    $show: Boolean
    $order: Long
    $id: String
    $mlName:Object
  ) {
    updateStyleManage(name: $name, show: $show, order: $order, id: $id,mlName:$mlName) {
      result
      info
      success
      error
    }
  }
`;

// 移除设计风格
export const REMOVE_OPUS_STYLE = gql`
  mutation _REMOVE_OPUS_STYLE($id: String!) {
    removeStyleManage(id: $id) {
      result
      info
      success
      error
    }
  }
`;

// 保存风格顺序
export const OPUS_STYLE_ORDER = gql`
  mutation _OPUS_STYLE_ORDER($ids: [String]) {
    saveStyleManageOrder(ids: $ids) {
      result
      info
      success
      error
    }
  }
`;

// 创建作品 id
export const CREATE_OPUS_ID = gql`
  mutation _CREATE_OPUS_ID {
    generateNewWorkId {
      result
      info
      error
      success
    }
  }
`;

// 创建作品 id
export const GENERATE_NEW_WORK_ID = gql`
  mutation  _GENERATE_NEW_WORK_ID{
    generateNewWorkId {
      result
      info
      error
      success
    }
  }
`;

// 取消作品 id
export const CANCEL_OPUS_ID = gql`
  mutation _CANCEL_OPUS_ID($id: String!) {
    cancelNewWork(id: $id) {
      result
      info
      error
      success
    }
  }
`;

// 创建作品
export const CREATE_OPUS = gql`
  mutation _CREATE_OPUS(
    $categoryId: String
    $styleId: String
    $workName: String
    $content: String
    $cover: String
    $spectacle: Boolean
    $clientId: String
    $clientType: Int
    $tags: [String]
    $id: String
  ) {
    createNewWork(
      categoryId: $categoryId
      styleId: $styleId
      workName: $workName
      content: $content
      cover: $cover
      spectacle: $spectacle
      clientId: $clientId
      clientType: $clientType
      tags: $tags
      id: $id
    ) {
      result
      info
      success
      error
    }
  }
`;

// 更新作品
export const UPDATE_OPUS = gql`
  mutation _UPDATE_OPUS(
    $categoryId: String
    $styleId: String
    $workName: String
    $content: String
    $cover: String
    $spectacle: Boolean
    $clientId: String
    $clientType: Int
    $tags: [String]
    $id: String
    $doRelease: Boolean
  ) {
    updateNewWork(
      categoryId: $categoryId
      styleId: $styleId
      workName: $workName
      content: $content
      cover: $cover
      spectacle: $spectacle
      clientId: $clientId
      clientType: $clientType
      tags: $tags
      id: $id
      doRelease: $doRelease
    ) {
      result
      info
      success
      error
    }
  }
`;

//作品公开私密
export const UPDATE_OPUS_SPECTACLE = gql`
  mutation _UPDATE_OPUS_SPECTACLE($id: String!, $spectacle: Boolean) {
    spectacleNewWork(id: $id, spectacle: $spectacle) {
      success
      info
      error
      result
    }
  }
`;

//作品复制
export const COPY_OPUS = gql`
  mutation _COPY_OPUS($clientId: String, $clientType: Int, $id: String) {
    copyNewWork(clientId: $clientId, clientType: $clientType, id: $id) {
      success
      info
      error
      result
    }
  }
`;

// 新查询作品
export const QUERY_OPUS = gql`
  query _QUERY_OPUS(
    $clientId: String
    $clientType: Int
    $categoryId: String
    $styleId: String
    $status: Int
    $sort: Int
    $page: Long
    $pageSize: Int
  ) {
    _newWorks(
      clientId: $clientId
      clientType: $clientType
      categoryId: $categoryId
      styleId: $styleId
      status: $status
      sort: $sort
      page: $page
      pageSize: $pageSize
    )
  }
`;

// 新查询作品详情
export const OPUS_DETAIL = gql`
  query _OPUS_DETAIL(
    $id: String
    $clientId: String
    $clientType: Int
    $sort: Int
  ) {
    _newWorksDetail(
      id: $id
      clientId: $clientId
      clientType: $clientType
      sort: $sort
    ) {
      success
      info
      error
      result
    }
  }
`;

// 作品库筛选查询
export const OPUS_FILTER = gql`
  query _OPUS_FILTER($clientId: String, $clientType: Int) {
    newWorkCategoryFilter(clientId: $clientId, clientType: $clientType) {
      result
      success
      info
      error
    }
  }
`;

// 修改作品是否首页展示
export const INDEX_STARED_WORKS = gql`
  mutation _INDEX_STARED_WORKS($id: String!,$indexStar:Boolean!) {
    indexStarNewWork(id: $id,indexStar:$indexStar) {
      result
      info
      error
      success
    }
  }
`;

//作品库列表首页查询接口  
export const QUERY_NEW_WORK_INDEX = gql`
  query _QUERY_NEW_WORK_INDEX($queryNewWorksParamDTO: Object ) {
    queryNewWorkIndexWithoutPage(queryNewWorksParamDTO:$queryNewWorksParamDTO ) {
      result
      info
      success
      error
    }
  }
`;
// export const QUERY_NEW_WORK_INDEX = gql`
//   query _QUERY_NEW_WORK_INDEX($clientId: String, $clientType: Int,$year: Int,$typeKey: String, $styleKey: String, $sort: Int,$sortField:String, $page: Int,$pageSize: Int,$searchContent: String,$customGroupField: Object ) {
//     queryNewWorkIndexWithoutPage(clientId: $clientId, clientType: $clientType,year: $year,typeKey: $typeKey,styleKey: $styleKey,sort: $sort,sortField:$sortField, page:$page,pageSize:$pageSize,searchContent:$searchContent,customGroupField:$customGroupField ) {
//       result
//       info
//       success
//       error
//     }
//   }
// `;

//作品库背景图查询
export const QUERY_WORK_BGIMG = gql`
  query _QUERY_WORK_BGIMG($clientId: String!, $clientType: Int! ) {
    queryWorkBgImg(clientId: $clientId, clientType: $clientType)
  }
`;

// 保存(个人/团队)作品总览  
export const SAVE_WORK_OC = gql`
mutation _SAVE_WORK_OC($clientId: String, $clientType: Int, $overviewText: String, $year:Int,$typeKey: String, $typeValue: String,$styleKey: String, $styleValue: String, $bgDto: WorkBgDto ) {
  saveWorkOC(clientId: $clientId, clientType: $clientType, overviewText:$overviewText, year: $year,typeKey: $typeKey,typeValue:$typeValue,styleKey: $styleKey,styleValue:$styleValue, bgDto: $bgDto) {
      result
      info
      success
      error
    }
  }
`;

// 新增作品展示数据 displayType=0
export const ADD_DISPLAY_INFOS = gql`
mutation _ADD_DISPLAY_INFOS($displays: [WorkDisplayDto] ) {
  addDisplayInfos(displays: $displays) {
      result
      info
      success
      error
    }
  }
`;

// 新版作品保存
export const SAVE_NEW_WORK = gql`
mutation _SAVE_NEW_WORK($workDto: Object ) {
  saveNewWork(workDto: $workDto) {
      result
      success
      info
      error
    }
  }
`;



// 查询作品展示|获奖证书  type: 0-作品展示  1-获奖证书
export const QUERY_DISPLAY_INFO = gql`
  query _QUERY_DISPLAY_INFO($wid: String, $type: Int, $pageSize: Int, $sort: Int, $completed: Boolean) {
    queryDisplayInfo(wid: $wid, type: $type,pageSize: $pageSize,sort: $sort,completed: $completed) {
      result
      info
      success
      error
    }
  }
`;


// 作品附件查询
export const QUERY_DOCUMENT = gql`
  query _QUERY_DOCUMENT($wid: String, $did: String, $sortField: String, $sort: Int) {
    queryDocument(wid: $wid, did: $did, sortField: $sortField, sort: $sort) {
      id
      name
      url
      wid
      type
      parentId
      discard
      level
      children
      tmCreate
      size
      classify
      creatorId
    }
  }
`;

// 作品附件数量查询
export const QUERY_DOCUMENT_NUMBER = gql`
  query _QUERY_DOCUMENT_NUMBER($wid: String, $did: String) {
    queryDocumentCount(wid: $wid, did: $did) {
      result
      success
      info
      error
    }
  }
`;



// 新建文件夹
export const ADD_DOCUMENT_FOLDER = gql`
  mutation _ADD_DOCUMENT_FOLDER($name: String!, $wid: String!, $parentId: String, $classify: Int,$creatorId: String) {
    addDocumentFolder(name: $name, wid: $wid, parentId: $parentId, classify: $classify,creatorId: $creatorId) {
        success
        result
        info
        error
      }
    }
`;

// 添加文档
export const ADD_DOCUMENT = gql`
  mutation _ADD_DOCUMENT($fileList: [DocumentDto], $wid: String!, $parentId: String, $classify: Int,$creatorId: String!) {
    addDocument(fileList: $fileList, wid: $wid, parentId: $parentId, classify: $classify,creatorId: $creatorId) {
        success
        result
        info
        error
      }
    }
`;

// 文件夹重命名
export const UPDATE_DOCUMENT_NAME = gql`
  mutation _UPDATE_DOCUMENT_NAME($id: String, $name: String) {
    updateDocumentName(id: $id, name: $name) {
        success
        result
        info
        error
      }
    }
`;

// 删除文档
export const DELETE_DOCUMENT = gql`
  mutation _DELETE_DOCUMENT($ids: [String]) {
    deleteDocument(ids: $ids) {
        success
        result
        info
        error
      }
    }
`;

// 预览附件
export const PREVIEW_DOCUMENT = gql`
  query _PREVIEW_DOCUMENT($id: String) {
    previewDocument(id: $id) {
      result
      info
      success
      error
    }
  }
`;

// 移动文档
export const MOVE_FILE = gql`
  mutation _MOVE_FILE($id: String!,$targetId: String) {
    moveFile(id: $id,targetId: $targetId) {
        success
        result
        info
        error
      }
    }
`;

// 根据作品id查询媒体宣传
export const QUERY_MEDIA_INFO = gql`
  query _QUERY_MEDIA_INFO($wid: String) {
    queryMediaInfo(wid: $wid) {
      result
      info
      success
      error
    }
  }
`;

// 新增修改媒体宣传 传id为修改/不传为新增
export const UPSERT_MEDIA_INFO = gql`
  mutation _UPSERT_MEDIA_INFO($info: MediaInfo) {
    upsertMediaInfo(info: $info) {
        success
        result
        info
        error
      }
    }
`;

// 删除媒体宣传
export const REMOVE_MEDIA_INFO = gql`
  mutation _REMOVE_MEDIA_INFO($id: String) {
    removeMediaInfo(id: $id) {
        success
        result
        info
        error
      }
    }
`;

// 管理员查询作品联系人信息
export const QUERY_WORK_CUSTOMER_INFO_BY_ADMIN = gql`
  query _QUERY_WORK_CUSTOM_INFO_BY_ADMIN($wid: String) {
    queryWorkCustomerInfoByAdmin(wid: $wid) {
      result
      info
      success
      error
    }
  }
`;

// 管理员修改作品客户信息
export const UPDATE_WORK_CUSTOMER_INFO = gql`
  mutation _REMOVE_MEDIA_INFO($wid: String,$info: CustomerInfo) {
    updateWorkCustomerInfo(wid: $wid,info: $info) {
        success
        result
        info
        error
      }
    }
`;

// 管理员修改作品客户信息
export const updateWorkCustomerInfo = async (body) => {
  return axios.post('/api/workCustom/updateWorkCustomerInfo', body)
}
// 新增vr信息
export const addDisplayInfos = async (body) => {
  return axios.post('/api/work/addDisplayInfos', body)
}

// 复制作品
export const COPY_NEW_WORK = gql`
  mutation _COPY_NEW_WORK($clientId: String,$clientType: Int,$id: String) {
    copyNewWork(clientId: $clientId,clientType: $clientType, id: $id) {
        success
        result
        info
        error
      }
    }
`;

// 删除作品
export const BATCH_DELETE_NEW_WORK = gql`
  mutation _BATCH_DELETE_NEW_WORK($ids: [String]) {
    batchDeleteNewWork(ids: $ids) {
        success
        result
        info
        error
      }
    }
`;

// 查询作品详情
export const QUERY_NEW_WORK_DETAIL = gql`
  query _QUERY_NEW_WORK_DETAIL($id: String) {
    queryNewWorkDetail(id: $id) {
      result
      info
      success
      error
    }
  }
`;

export const findNewWorkDetailInfo = async (id) => {
  const url = `/api/work/findNewWorkDetailInfo?id=${id}`
  return axios.get(url)
}

export const queryNewWorkDetailInfo = async (id) => {
  const url = `/api/work/queryNewWorkDetailInfo?id=${id}`
  const axios = axiosLang();
  return axios.get(url)
}

// 修改作品展示|获奖证书
export const UPDATE_DISPLAY_INFO = gql`
  mutation _UPDATE_DISPLAY_INFO($id: String,$displayName: String,$displayUrl: String,$vrFrame: String,$frame: String, $desc: String,$mlDisplayName: Object,$mlDesc: Object,$doDelete: Boolean,$urlItems: [WorkDocUrlItem]) {
    updatedDisplayInfo(id: $id,displayName: $displayName,displayUrl: $displayUrl,vrFrame: $vrFrame,frame: $frame,desc: $desc,mlDisplayName:$mlDisplayName,mlDesc:$mlDesc,doDelete: $doDelete,urlItems:$urlItems) {
        success
        result
        info
        error
      }
    }
`;
// 修改作品展示|获奖证书
export const updatedDisplayInfoV2 = async (body) => {
  return axios.post('/api/WorkDisplayInfo/updatedDisplayInfoV2', body)
}
// 查找所有 所有的作品的信息
export const findDisplayInfo = async (body) => {

  return axios.post('/api/work/findDisplayInfo', body)
}
// 查找所有的 管理员可见的数据
export const queryWorkCustomerInfoByAdminInfo = async (id) => {
  const url = `/api/workCustom/queryWorkCustomerInfoByAdminInfo?wid=${id}`
  return axios.get(url)
}

// 根据作品展示修改作品封面
export const UPDATE_COVER_BY_DIS = gql`
  mutation _UPDATE_COVER_BY_DIS($id: String,$wid: String,$displayUrl: String) {
    updateCoverByDis(id: $id,wid: $wid,displayUrl: $displayUrl) {
        success
        result
        info
        error
      }
    }
`;

// 删除作品展示|获奖证书
export const REMOVE_DISPLAY_INFO = gql`
  mutation _REMOVE_DISPLAY_INFO($id: String) {
    removeDisplayInfo(id: $id) {
        success
        result
        info
        error
      }
    }
`;

// 管理员设置作品模板
export const AS_TEMPLATE_WORK = gql`
  mutation _AS_TEMPLATE_WORK($clientId: String,$clientType: Int,) {
    asTemplateWork(clientId: $clientId,clientType: $clientType) {
        success
        result
        info
        error
      }
    }
`;

// 作品初始化
export const INIT_WORK = gql`
  mutation _INIT_WORK($clientId: String,$clientType: Int,) {
    initWork(clientId: $clientId,clientType: $clientType) {
        success
        result
        info
        error
      }
    }
`;

// 获取分享的作品数据
export function GET_VISIT_WORK(params) {
  return post('/api/visit/getVisitWork?key=' + params, {})
}

// 作品下是否存在附带信息
export const EXIST_EXTRA_INFO = gql`
query _EXIST_EXTRA_INFO($wid: String!) {
    existExtraInfo(wid: $wid) {
        success
        result
        info
        error
      }
    }
`;

// 添加资材标注锚点
export function ADD_MARKER(params) {
  return post('/api/dp/add', params)
}

// 修改资材标注锚点
export function UPDATE_MARKER(params) {
  return post('/api/dp/update', params)
}

// 删除资材标注锚点
export function DELETE_MARKER(params) {
  return post('/api/dp/delete', params)
}

// 获取标注锚点
export function GET_MARKER(params) {
  return post('/api/dp/queryByDid', params)
}

// 获取所有标注锚点
export function queryByWid(params) {
  return post('/api/dp/queryByWid', params)
}

// 锚点排序
export function MOVE_MARKER(params) {
  return post('/api/dp/move', params)
}

// 批量删除锚点
export function BATCH_DELETE_MARKER(params) {
  return post('/api/dp/batchDelete', params)
}

// 作品拖动排序
export function WORK_MOVE(params) {
  return post('/api/work/move', params)
}

// 作品拖动排序
export function WORK_V2_MOVE(params) {
  return post('/api/work/v2/move', params)
}

// 作品图片拖动排序
export function WORK_DISPLAT_INFO_MOVE(params) {
  return post('/api/workdisplayinfo/move', params)
}

// 作品修改图片展览状态
// status 0已完成 1进行中 2失败
export function WORK_DISPLAT_INFO_UPDATE_STATUS(params) {
  return post('/api/workdisplayinfo/updateStatus', params)
}

// // 作品查询作品下是否存在上传中的展览
// export function QUERY_COMPLETED_BY_WID(id) {
//   return get('/api/workdisplayinfo/queryCompletedByWId?id=' + id)
// }

// 作品媒体是否在上传
export async function workdisplayinfoExistExtraInfo(workId) {
  const axios = axiosLang();
  let res = await axios.get('/api/work/existExtraInfo?id=' + workId)
  return res.data.result;
}

// 作品下是否存在附带信息
export async function workdisplayinfoUploadingIsCompleted(workId) {
  const axios = axiosLang();
  let res = await axios.get('/api/workdisplayinfo/queryCompletedByWId?id=' + workId)
  return res.data.result;
}

// 作品拖动合并类型
export function workBatchUpdateCategory(params) {
  return post('/api/work/batchUpdateCategory', params)
}

// 作品拖动合并类型
export function workBatchUpdateStyle(params) {
  return post('/api/work/batchUpdateStyle', params)
}

// 查询是否存在重名类型分类, 返回值 true - 存在重名分类 false - 不存在重名分类
export function workQueryDupCatName(params) {
  return post('/api/work/queryDupCatName', params)
}

// 查询是否存在重名风格分类, 返回值 true - 存在重名分类 false - 不存在重名分类
export function workQueryDupStyleName(params) {
  return post('/api/work/queryDupStyleName', params)
}

// 图片压缩
export function uploadImgInQueue(params) {
  return post('/api/uploadImgInQueue', params)
}

// 图片压缩 图搜图专用
export function productUploadImgInQueue(params) {
  return post('/api/productUploadImgInQueue', params)
}

// 视频压缩|转第一帧
export function uploadVideoInQueue(params) {
  return post('/api/uploadVideoInQueue', params)
}

// 保存作品分类-风格顺序
export function workOcMove(params) {
  return post('/api/workOc/move', params)
}

// 作品搜索
export function workQueryByKey(params) {
  return post('/api/work/queryByKey', params)
}

// 同步删除作品文件夹
export function deleteWorkLib(params) {
  return post('/api/cloud/deleteWorkLib', params)
}

// 创建作品 id
export function generateNewWorkIdPost(params) {
  return post('/api/work/generateNewWorkId', params)
}

// 取消作品
export function cancelNewWorkPost(params) {
  return post('/api/work/cancelNewWork', params)
}

// 根据产品id获取作品案例
// lang 由调用方传入当前页面语言（用户当前切换到的语言），避免请求头取到过期语言
export async function workQueryByProduct(productId, model, lang) {
  const axios = axiosLang(lang);
  let res = await axios.get('/api/work/queryByProduct?id=' + productId + (model ? '&model=' + model : ''))
  return res;
}

// 查询作品展览（移动端旧版  PC锚点使用）
export function queryDisplayInfo(params) {
  return post('/api/work/queryDisplayInfo', params)
}

// 查询作品展览（移动端新版）
export function queryDisplayInfoMP(params) {
  return post('/api/work/queryDisplayInfoMP', params)
}

// 保存作品视频压缩
// convertType; 传1 "作品类型: 1.作品"
// clientType;  传1 "客户端类型,1.PC"
// status;  Origin:不需要压缩 Queued：需要
export function saveWorkVideo(params) {
  return post('/api/workVideo/saveWorkVideo', params)
}

// 查询作品视频压缩
export async function findWorkVideo(convertId) {
  const axios = axiosLang();
  let res = await axios.get('/api/workVideo/findWorkVideo?convertId=' + convertId)
  return res;
}

// 查新模块开关
export function queryHomeBaseConfig(params) {
  return post('/api/homeBase/query_home_base_config', params)
}

//查询权限
export async function queryByTeamIdAndRole(teamId, role) {
  const axios = axiosLang();
  let res = await axios.get(`/api/queryByTeamIdAndRole?teamId=${teamId}&role=${role}`)
  return res;
}

// 设置作品保密级别
export function workSetSecretArray(params) {
  return post('/api/work/setSecretArray', params)
}

// 作品 根据作品id查询作品信息
export async function queryNewWorkDetail(id) {
  const axios = axiosLang();
  let res = await axios.get(`/api/work/queryNewWorkDetail?id=${id}`)
  return res;
}

// // 作品 根据作品id查询作品信息,多语言
// export async function queryNewWorkDetailInfo(id) {
//   const axios = axiosLang();
//   let res = await axios.get(`/api/work/queryNewWorkDetailInfo?id=${id}`)
//   return res;
// }

// 查询设置作品table排序
export async function findWorkTableSortByUserId(userId) {
  const axios = axiosLang();
  let res = await axios.get(`/api/work/findWorkTableSortByUserId?userId=${userId}`)
  return res;
}

// 设置作品table排序
export function updateWorkTableSort(params) {
  return post('/api/work/updateWorkTableSort', params)
}

// 查询自定义字段
export async function findNewWorksOverviewConf(clientId, clientType) {
  const axios = axiosLang();
  let res = await axios.get(`/api/workGroup/findNewWorksOverviewConf?clientId=${clientId}&clientType=${clientType}`)
  return res;
}

// 查询自定义字段 国际版本
export async function findNewWorksOverviewConfMultiLanguage(clientId, clientType) {
  const axios = axiosLang();
  let res = await axios.get(`/api/workGroup/findNewWorksOverviewConfMultiLanguage?clientId=${clientId}&clientType=${clientType}`)
  return res;
}

// 编辑自定义字段
export function updateCustomGroupField(params) {
  return post('/api/workGroup/updateCustomGroupField', params)
}

// 置顶作品
export async function updatePinned(id, pinned) {
  const axios = axiosLang();
  let res = await axios.get(`/api/work/updatePinned?id=${id}&pinned=${pinned}`)
  return res;
}

// 添加更新关联项目信息
export function upsertProjectInfo(params) {
  return post('/api/workProject/upsertProjectInfo', params)
}

// 删除关联项目信息
export function removeProjectInfo(params) {
  return post('/api/workProject/removeProjectInfo', params)
}

// 查询关联项目信息
export function queryProjectInfo(params) {
  return post('/api/workProject/queryProjectInfo', params)
}
// 拆寻国际化的关联项目
export function queryProjectInfoLang(params) {
  return post('/api/workProject/queryProjectInfoMultiLanguage', params)

}


// 翻译功能
export function translateBatch(params) {
  return post('/api/translate/batch', params)
}

// 作品合集 /api/newWorkConfValue/findTeamNewWorkCollection
export function FindTeamNewWorkCollection(params) {
  return get({url:'/api/newWorkConfValue/findTeamNewWorkCollection?'+ new URLSearchParams(params).toString()})
}

// 作品联想下拉数据 /api/newWorkValue/findNewWorkCustomValueFuzzySearch
export function findNewWorkCustomValueFuzzySearch(params) {
  return post('/api/newWorkValue/findNewWorkCustomValueFuzzySearch', params)
}


// 设置作品视图排列 /api/work/updateNewWorkViewStatus
export function updateNewWorkViewStatus(params) {
  return post('/api/work/updateNewWorkViewStatus', params)
}

// 查询设置作品视图排列 /api/work/findNewWorkViewStatus
export function findNewWorkViewStatus(params) {
  return get({url:'/api/work/findNewWorkViewStatus?'+ new URLSearchParams(params).toString()})
}


// 照片墙  /api/work/queryDisplayAlbum
export function queryDisplayAlbum(params) {
  return post('/api/work/queryDisplayAlbum',params)
}

// 设置作品图片排序锁
export function setWorkDisplaySortLock(params) {
  return post('/api/workDisplayInfo/setWorkDisplaySortLock',params)
}

// 删除作品图片排序锁 /api/workDisplayInfo/removeWorkDisplaySortLock
export function removeWorkDisplaySortLock(params) {
  return post('/api/workDisplayInfo/removeWorkDisplaySortLock',params)
}

// 批量删除作品图片
export function batchDelete(params) {
  return post('/api/workdisplayinfo/batchDelete',params)
}

// 替换 groupql的接口的方法
export function queryNewWorkList(params){
  return fetchLang('/api/work/queryNewWorkList', {
		method: "POST",
		headers,
		body: JSON.stringify(params)
	}).then(res => res.json())
  // return post("/api/work/queryNewWorkList",params)
} 

// 2026 年新版作品保存
export function saveNewWork  (params) {
  return post('/api/work/saveNewWork ',params)
}

// 2026 年新版 媒体宣传功能
export function upsertMediaInfo  (params) {
  return post('/api/work/upsertMediaInfo ',params)
}


// 2026 年新版 媒体宣传功能删除功能
export function removeMediaInfo  (params) {
  return get({
    url:'/api/work/removeMediaInfo?'+ new URLSearchParams((params)).toString()
  })
}

// 2026 年新版 媒体宣传功能删除功能
export function removeDisplayInfo  (params) {
  return get({
    url:'/api/workDisplayInfo/removeDisplayInfo?'+ new URLSearchParams((params)).toString()
  })
}

// 查询卡片布局(上次保存的卡片宽度) /api/work/cardLayout/query
export function queryWorkCardLayout(params) {
  return get({
    url:'/api/work/cardLayout/query?'+ new URLSearchParams((params)).toString()
  })
}

// 保存卡片布局(卡片宽度) /api/work/cardLayout/save
export function saveWorkCardLayout(params) {
  return post('/api/work/cardLayout/save', params)
}

